@import "config";

.breadcrumbsContainer {
	@include flex(row, flex-start, center);

	.openMenuIcon {
		cursor: pointer;
		margin-right: $spacing-inline-xxxs;
	}

	.crumb {
		@include flex(row, flex-start, center);

		* {
			display: inline-flex;
			text-transform: uppercase;
			font-size: $font-size-xxxs;
			font-weight: $font-weight-bold;
		}

		a[href] {
			cursor: pointer;
			color: var(--color-primary-pure);
			text-decoration: underline;
			text-underline-offset: 3px;
		}

		&:not(:last-child) {
			&:after {
				content: "/";
				font-size: $font-size-xxxs;
				color: var(--color-primary-pure);
				font-weight: $font-weight-bold;
				margin: 0 $spacing-inline-quarck;
			}
		}

		&:last-child *,
		a:not([href]) {
			color: $color-dark-d1;
		}
	}
}